// ====================
// Negratta Theme JavaScript
// ====================

document.addEventListener('DOMContentLoaded', function() {
  // ----- Menú móvil -----
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
      document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
    });
  }

  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', function() {
      mobileMenu.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  // Cerrar menú al hacer clic fuera
  if (mobileMenu) {
    mobileMenu.addEventListener('click', function(e) {
      if (e.target === this) {
        this.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }

  // ----- Carrito Drawer (toggle y lógica básica) -----
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartClose = document.querySelector('[data-cart-drawer-close]');
  const cartOverlay = document.querySelector('[data-cart-drawer-overlay]');

  if (cartToggle && cartDrawer) {
    cartToggle.addEventListener('click', function(e) {
      e.preventDefault();
      cartDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }

  const closeCart = function() {
    if (cartDrawer) {
      cartDrawer.classList.remove('active');
      document.body.style.overflow = '';
    }
  };

  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Cerrar con ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('active')) {
      closeCart();
    }
  });

  // ----- Acordeones -----
  document.querySelectorAll('.accordion-item__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const content = this.nextElementSibling;
      const expanded = this.getAttribute('aria-expanded') === 'true' || false;

      // Cerrar otros acordeones en el mismo grupo (opcional)
      // Si quieres que solo uno se abra, descomenta:
      // const parent = this.closest('.faq-summary__list, .page-faq__group-items, .product-main__accordion');
      // if (parent) {
      //   parent.querySelectorAll('.accordion-item__trigger').forEach(other => {
      //     if (other !== this) {
      //       other.setAttribute('aria-expanded', 'false');
      //       other.nextElementSibling.setAttribute('hidden', '');
      //     }
      //   });
      // }

      this.setAttribute('aria-expanded', !expanded);
      if (!expanded) {
        content.removeAttribute('hidden');
      } else {
        content.setAttribute('hidden', '');
      }
    });
  });

  // ----- Añadir al carrito (sticky) -----
  document.querySelectorAll('[data-add-to-cart-sticky]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const form = document.getElementById('product-form');
      if (form) {
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.click();
      }
    });
  });

  // ----- Comprar ahora (botón principal y sticky): agrega vía Ajax y va directo a checkout -----
  document.querySelectorAll('[data-buy-now], [data-buy-now-sticky]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const form = document.getElementById('product-form');
      if (!form) return;
      const formData = new FormData(form);
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function(response) { return response.json(); })
        .then(function() {
          window.location.href = '/checkout';
        })
        .catch(function() {
          btn.disabled = false;
        });
    });
  });

  // ----- Actualizar contador del carrito (ejemplo con eventos) -----
  // Esta es una implementación básica, se debería integrar con el API de Shopify
  const updateCartCount = function(count) {
    const counter = document.querySelector('[data-cart-count]');
    if (counter) {
      counter.textContent = count;
    }
  };

  // Escuchar cambios en el carrito vía eventos personalizados (puedes integrar con ajax cart)
  document.addEventListener('cart:updated', function(e) {
    if (e.detail && e.detail.item_count !== undefined) {
      updateCartCount(e.detail.item_count);
    }
  });

  // ----- Inicializar contador desde el carrito actual (si existe) -----
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateCartCount(cart.item_count);
    })
    .catch(() => {});

  // ----- Placeholder para más interacciones (por ejemplo, filtros) -----
});